import * as _ from 'lodash';

/**
 * Auto Answers Results (Index) model
 * @param chatId
 *  <fields>
 <field name="AutoAnswersIndexID" type="long" generateIfNull="true"/>
 <field name="AccountID" type="long" useAccountIDIfNull="true"/>
 <field name="AutoAnswersQuestionID" type="long"/>
 <field name="CannedMessageID" type="long"/>
 <field name="Status" type="byte"/>
 <field name="Type" type="byte"/>
 <field name="LanguageCode" type="text" size="2" default="en"/>
 <field name="AutoAnswersSettingsID" type="long"/>
 <field name="RelatedToID" type="long"/>
 <field name="ServiceType" type="byte"/>
 <field name="Score" type="double"/>
 <field name="Votes" type="long"/>
 <field name="Rank" type="integer"/>
 <field name="Created" type="created" allowsUpdates="false"/>
 * </fields>
 *
 * @constructor
 */

export class AutoAnswersResults {
  static comparator(aaQuestion1, aaQuestion2) {
    return aaQuestion1.AutoAnswersIndexID === aaQuestion2.AutoAnswersIndexID;
  }

  static wrap(event) {
    return new AutoAnswersResults(event.data);
  }

  constructor(autoAnswersResultsRecord) {
    _.assign(this, autoAnswersResultsRecord);
  }
}
